import { useState, useEffect } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";
import "./../Header/profile.css";
import "./../Header/logout-popup.css";
import { CiWarning } from "react-icons/ci";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div className="modal-overlay">
      {user.role === "admin" ? (
        <div className="modal-content">
          {/* Close icon in the top-right corner */}
          <span className="close-icon" onClick={onClose}>
            ✖
          </span>
          {children}
        </div>
      ) : (
        <div className="employee-manager-teamleader-profile-container-modal-content ">
          {/* Close icon in the top-right corner */}
          <span className="close-icon" onClick={onClose}>
            ✖
          </span>
          {children}
        </div>
      )}
    </div>
  );
};
const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [role, setRole] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false); // State to control the confirmation modal
  const navigate = useNavigate();
  // Fetch user profile immediately when the page loads
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role) {
      setRole(user.role);
      fetchUserProfile(user); // Fetch profile immediately on load
    } else {
      setRole("Role not found.");
    }
  }, []);

  const fetchUserProfile = async () => {
    setLoading(true);
    setError(null);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id || !user.role) {
        throw new Error("User not found in localStorage.");
      }
      let apiUrl = "";
      if (user.role === "admin") {
        apiUrl = `https://aligndesk.dropyourbusiness.com/api/admin/${user.id}`;
      } else if (
        user.role === "employee" ||
        user.role === "manager" ||
        user.role === "Team Leader"
      ) {
        apiUrl = `https://aligndesk.dropyourbusiness.com/api/emp/${user.id}`;
      } else {
        throw new Error("Invalid role.");
      }
      console.log("Fetching from:", apiUrl);
      const response = await fetch(apiUrl);
      if (!response.ok) {
        if (response.status === 404) {
          setError("Profile not found.");
        } else {
          setError(`Failed to fetch user data. Status: ${response.status}`);
        }
        return;
      }
      const data = await response.json();
      console.log("API Response Data:", data);
      setUserData(data.admin || data.employee || null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const openProfileModal = () => {
    setIsModalOpen(true);
    fetchUserProfile();
  };

  // Handle click on the logout button
  const handleLogoutClick = () => {
    console.log("Logout button clicked"); // Debugging line
    setShowLogoutConfirm(true); // Set the state to show the confirmation modal
  };
  // Actual logout function
  const handleLogout = () => {
    localStorage.clear();
    setDropdownOpen(false);
    navigate("/");
  };
  // When the user confirms the logout action
  const handleConfirmLogout = () => {
    console.log("User confirmed logout"); // Debugging line
    handleLogout(); // Proceed with logout
    setShowLogoutConfirm(false); // Hide the confirmation modal
  };
  // When the user cancels the logout action
  const handleCancelLogout = () => {
    console.log("User cancelled logout"); // Debugging line
    setShowLogoutConfirm(false); // Close the confirmation modal
  };
  return (
    <div className="header">
      <div className="header-left"></div>
      <div
        className="header-right"
        onClick={() => setDropdownOpen((prev) => !prev)}
      >
        <div className="greeting-container">
          {/* Display Name */}
          <span className="user-name">
            {role === "admin"
              ? userData?.admin_fullname
                  ?.split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")
              : `${
                  userData?.employee_first_name?.charAt(0).toUpperCase() +
                  userData?.employee_first_name?.slice(1)
                } 
         ${
           userData?.employee_last_name?.charAt(0).toUpperCase() +
           userData?.employee_last_name?.slice(1)
         }`}
            ,
          </span>
          {/* Display Designation Only for Employee, Manager, Team Leader */}
          {role === "admin" ? (
            <span className="designation">
              {role.charAt(0).toUpperCase() + role.slice(1)}
            </span>
          ) : (
            <span className="designation">
              {userData?.employee_type
                ? userData.employee_type.charAt(0).toUpperCase() +
                  userData.employee_type.slice(1)
                : "No Designation"}{" "}
              |{" "}
              {role ? role.charAt(0).toUpperCase() + role.slice(1) : "No Role"}
            </span>
          )}
        </div>
        <div className="profile-icon">
          {userData ? (
            <img
              src={
                role === "admin"
                  ? userData.admin_profile || "../images/icon.png"
                  : role === "team_leader"
                  ? userData.employee_profile || "../images/icon.png"
                  : role === "manager"
                  ? userData.employee_profile || "../images/icon.png"
                  : userData.employee_profile || "../images/icon.png"
              }
              alt="Profile"
              className="profile-img"
            />
          ) : (
            <img
              src={
                role === "admin"
                  ? "/images/icon.png"
                  : role === "manager"
                  ? "../images/icon.png"
                  : "../images/icon.png"
              }
              alt="Default Profile"
              className="header-profile-img"
            />
          )}
        </div>
      </div>
      {dropdownOpen && (
        <div className="dropdown">
          <ul>
            <li onClick={openProfileModal}>My Profile</li>
            <li onClick={handleLogoutClick}>Logout</li>
          </ul>
        </div>
      )}
      {/* Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            {/* Popup Header with Icon */}
            <div className="popup-header">
              <CiWarning />
              {/* Warning icon */}
              {/* Logout icon */}
              <span>Confirm Logout</span>
            </div>
            <p className="p">
              Are you sure you want to log out{" "}
              {/* Dynamically display the full name based on the role */}
              <strong>
                {role === "admin" && userData?.admin_fullname}
                {(role === "manager" ||
                  role === "employee" ||
                  role === "Team Leader") &&
                  userData?.employee_first_name && (
                    <>
                      {`${userData.employee_first_name} ${userData.employee_middle_name} ${userData.employee_last_name}`}
                    </>
                  )}
              </strong>
              ?
            </p>
            <div className="modal-buttons">
              <button onClick={handleConfirmLogout}>Yes, Logout</button>
              <button onClick={handleCancelLogout}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        style={{ width: "500px" }}
      >
        <h2>My Profile</h2>
        {loading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {userData && (
          <div className="profile-container">
            {userData && (
              <div className="mprofile-image">
                <img
                  src={
                    role === "admin"
                      ? userData.admin_profile || "../images/icon.png"
                      : role === "team_leader"
                      ? userData.employee_profile || "../images/icon.png"
                      : role === "manager"
                      ? userData.employee_profile || "../images/icon.png"
                      : userData.employee_profile || "../images/icon.png"
                  }
                  alt="Profile"
                  className="mprofile-img"
                />
              </div>
            )}
            <div className="profile-details">
              {role === "admin" && (
                <>
                  <div className="detail-item">
                    <strong>Name:</strong>{" "}
                    <span>{userData.admin_fullname}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Email:</strong> <span>{userData.admin_email}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Address:</strong>{" "}
                    <span>{userData.admin_address}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Contact:</strong>{" "}
                    <span>{userData.admin_contact}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Gender:</strong>{" "}
                    <span>{userData.admin_gender}</span>
                  </div>
                </>
              )}
              {(role === "manager" ||
                role === "employee" ||
                role === "Team Leader") && (
                <>
                  <div className="detail-item">
                    <strong>Full Name:</strong>{" "}
                    <span>{`${userData.employee_first_name} ${userData.employee_middle_name} ${userData.employee_last_name}`}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Email:</strong>
                    <span>{userData.employee_email}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Address:</strong>{" "}
                    <span>{`${userData.employee_address}, ${userData.employee_city}, ${userData.employee_state}, ${userData.employee_pincode}`}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Contact:</strong>{" "}
                    <span>{userData.employee_contact}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Gender:</strong>{" "}
                    <span>{userData.employee_gender}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Department:</strong>
                    <span>{userData.department?.department_name || "N/A"}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};
export default Header;
